import { Link } from 'react-router-dom';
import type { FC } from 'react';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: FC<BreadcrumbProps> = ({ items }) => {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-base"></i>
            )}
            {item.to ? (
              <Link
                to={item.to}
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE(item.to!);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;